export type Lang = 'fr' | 'en';

export function formatPrice(amount: number, lang: Lang = 'fr'): string {
  const formatted = amount
    .toFixed(3)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  return `${formatted} TND`;
}

export function formatPriceShort(amount: number, lang: Lang = 'fr'): string {
  const formatted = amount
    .toFixed(3)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  return `${formatted} TND`;
}

export function formatPriceInput(amount: number, lang: Lang = 'fr'): string {
  return amount.toFixed(3).replace('.', ',');
}
